import * as React from "react";

const MarketingInfo: React.FC = () => {
    return (
        <div className="flex flex-col gap-4 mt-8 text-neutral-400 text-sm">
            <div className="space-y-1">
                <h3 className="font-semibold text-neutral-200">
                    The AI platform built specifically for Australian and New Zealand legal professionals
                </h3>
                <p>
                    AI Legal Assistant is trusted by 230+ law firms across Australia and New Zealand to deliver accurate,
                    jurisdiction-specific legal research and support. As the official AI training partner of the ACT Bar
                    Association – the first Australian bar association to formally partner with an AI platform – we’re setting the
                    standard for professional legal AI education.
                </p>
            </div>

            <div className="space-y-1">
                <h3 className="font-semibold text-neutral-200">Built for Commonwealth Law</h3>
                <p>
                    Unlike US-focused alternatives, our platform is purpose-built for the Australian and New Zealand legal
                    landscape. We understand Commonwealth law, local jurisdictions, and the unique challenges facing legal
                    professionals in our region.
                </p>
            </div>

            <div className="space-y-1">
                <h3 className="font-semibold text-neutral-200">Accuracy You Can Trust</h3>
                <p>
                    Developed in partnership with managing partners, barristers, King’s Counsel, and Chief Justices, our AI
                    delivers the precision and reliability that legal work demands. We don’t just provide answers – we provide
                    answers you can rely on.
                </p>
            </div>

            <div className="space-y-1">
                <h3 className="font-semibold text-neutral-200">Enterprise-Grade Security</h3>
                <p>
                    All data is stored in Australia with ISO 27001 and SOC 2 Type II certifications, ensuring your client
                    information and sensitive legal work meets the highest standards of security and compliance.
                </p>
            </div>

            <div className="space-y-1">
                <h3 className="font-semibold text-neutral-200">Proven Track Record</h3>
                <p>
                    Serving firms of all sizes across Australia and New Zealand, from sole practitioners to established practices,
                    we’ve grown through results, not hype. Our clients choose us because we deliver on the promise of AI that
                    genuinely makes legal work faster, more accurate, and more efficient.
                </p>
            </div>
        </div>
    );
};

export default MarketingInfo;
